import { createContext, type ReactNode, useContext } from "react";
import { createPortal } from "react-dom";

/**
 * Places the app shell leaves open for the page on screen: the search bar in the top bar and the
 * side column (folders, lists). On phones the side column is a drawer opened from the top bar.
 */
export interface ShellSlots {
  search: HTMLElement | null;
  sidebar: HTMLElement | null;
  closeDrawer: () => void;
}

export const ShellSlotsContext = createContext<ShellSlots>({
  search: null,
  sidebar: null,
  closeDrawer: () => {},
});

export function useShell(): ShellSlots {
  return useContext(ShellSlotsContext);
}

/** Renders the page's search form into the top bar. */
export function ShellSearch({ children }: { children: ReactNode }) {
  const { search } = useShell();
  return search ? createPortal(children, search) : null;
}

/** Renders the page's side column into the shell (desktop column, phone drawer). */
export function ShellSidebar({ children }: { children: ReactNode }) {
  const { sidebar } = useShell();
  return sidebar ? createPortal(children, sidebar) : null;
}
